export const PRECISION = 3;
export const SCALE = 10 ** 3;
